import Naluri from '~/common/api/naluri'
import {
  SESSION_LOGIN_BEGIN,
  SESSION_LOGIN_SUCCESS,
  SESSION_LOGIN_FAILURE,
  SESSION_LOGIN_DISMISS_ERROR,
} from './constants';

import Cookie from '~/common/cookie'

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function login (args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: SESSION_LOGIN_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = Naluri.post('/api/expert/sessions', args)
      doRequest.then(
        (res) => {
          if (res.token) {
            Cookie.set('__naluri__', res.token)
            dispatch({
              type: SESSION_LOGIN_SUCCESS,
              data: (res.user) ? res.user : res,
            });
          } else {
            dispatch({
              type: SESSION_LOGIN_FAILURE,
              data: { error: res },
            });
          }

          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: SESSION_LOGIN_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissLoginError() {
  return {
    type: SESSION_LOGIN_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SESSION_LOGIN_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        authenticated: null,
        loginPending: true,
        loginError: null,
      };

    case SESSION_LOGIN_SUCCESS:
      // The request is success
      return {
        ...state,
        authenticated: action.data,
        token: action.data.token,
        loginPending: false,
        loginError: null,
      };

    case SESSION_LOGIN_FAILURE:
      // The request is failed
      return {
        ...state,
        authenticated: null,
        token: null,
        loginPending: false,
        loginError: action.data.error,
      };

    case SESSION_LOGIN_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        loginError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/session/redux/login.js